var map = {
	"./block_nether_flat.svg": "ae81",
	"./block_nether_surface.svg": "90d7",
	"./block_other.svg": "47ea",
	"./block_other_flat.svg": "98b6",
	"./block_skylands.svg": "ac19",
	"./block_the_end_flat.svg": "7075",
	"./block_the_end_surface.svg": "998a",
	"./block_world_biome.svg": "c7df",
	"./block_world_cave.svg": "4ef2",
	"./block_world_flat.svg": "fc7e",
	"./block_world_surface.svg": "bc3f",
	"./chat.svg": "9b69",
	"./checkbox.svg": "5b02",
	"./clock_moon.svg": "41c1",
	"./clock_moon_rain.svg": "9129",
	"./clock_moon_storm.svg": "686f",
	"./clock_sun.svg": "913f",
	"./clock_sun_rain.svg": "0881",
	"./clock_sun_storm.svg": "46de",
	"./compass.svg": "7259",
	"./layers.svg": "626a",
	"./link.svg": "40a1",
	"./loading.svg": "1e31",
	"./maps.svg": "a549",
	"./players.svg": "8cbd",
	"./settings.svg": "9174"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";